export default __webpack_public_path__ + "static/media/11-Building-and-construction-expo.28b8821a.jpg";